module.exports = __webpack_public_path__ + "media/images/logo_footer-c4609ef2ab46444d3b4a3af282461c32.png";